import React from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";

import { Img, Icon, Text, Toast } from "component";
import Clipboard from "@react-native-clipboard/clipboard";

import { sizes, colors } from "asset/constant";
import { logo } from "asset/logo";
import { css } from "style";
import { mq } from "utils";
import { useRecoilValue } from "recoil";
import { authAtom } from "store";

export default function UserCodeAlert() {
  const auth = useRecoilValue(authAtom);

  const _onCopyCode = () => {
    if (auth?.user?.code) {
      Clipboard.setString(auth?.user?.code);
      Toast.success({ message: "کد کپی شد" });
    }
  };

  return (
    <>
      <Img
        style={styles.image}
        source={logo.entries_screens}
        resizeMode={"contain"}
      />

      <View style={{ marginBottom: 5 }}>
        <Text weight="extraBold" size={"lg"} align="center">
          کد کاربری شما
        </Text>
      </View>
      <Text color={colors.text.muted} align="center">
        برای کپی کردن کد، بر روی آن ضربه بزنید
      </Text>
      <TouchableOpacity
        activeOpacity={0.7}
        onPress={_onCopyCode}
        style={[
          css.selfCenter,
          css.rRowCenterAlign,
          css.radius(sizes.radius.md),
          css.border(1, colors.theme),
          css.padding(2),
          css.marginY(15),
          css.bgColor(colors.theme + "11"),
        ]}
      >
        <Text
          lang="en"
          style={{ marginHorizontal: mq(10), top: mq(1) }}
          color={colors.theme}
          weight="extraBold"
          size={"xxxl"}
        >
          {auth?.user?.code}
        </Text>

        <View
          style={[
            css.square(mq(35)),
            css.centralElements,
            css.bgColor(colors.theme),
            css.radius(sizes.radius.sm),
          ]}
        >
          <Icon size={mq(18)} color={colors.white} name={"copy1"} />
        </View>
      </TouchableOpacity>

      <View style={css.padding(35)}>
        <Text weight="bold" style={{ lineHeight: mq(25) }} align="center">
          برای ثبت سفارش از شرکت های مورد نظر، لطفا کد کاربری خود را برای مدیر
          شرکت ارسال نموده و منتظر تایید بمانید.{"\n"}
          {"\n"}
          <Text size={"sm"} align="center" color={colors.text.muted}>
            برای دسترسی مجدد به کد کاربری خود به بخش پروفایل مراجعه کنید
          </Text>
        </Text>
      </View>
    </>
  );
}
const styles = StyleSheet.create({
  image: { aspectRatio: 2, width: "100%", maxWidth: 300, alignSelf: "center" },
});
